/**
 * Created by: cparaschiv
 * Date: 21.03.2013, 16:18
 */

(function () {
    'use strict';

    var unwrap = TS.unwrap,
        defaults = {
            Code: '',
            Text: '',
            IconCode: '',
            Visible: true,
            Enabled: true,
            Hint: ''
        },
        observableProps = ['Enabled', 'Visible', 'Text', 'IconCode', 'Hint'];

    /**
     * @class TS.domain.Command
     * @classdesc Abstraction of the command pattern.
     * Visually represented by a link or button, but multiple UI items can be bound to a command.
     */
    TS.domain.Command = new Class(
        /** @lends TS.domain.Command# */
        {
            Extends: TS.domain.CommandContainer,

            /**
             * Name of the client-side function that will be executed when the command is performed.
             * If the current view model has no such function the server-side command denoted by the <code>Code</code> property will be executed.
             * @member {String}
             */
            handler: null,

            /**
             * Command code. Usually prefixed by category code (e.g.: 'Record.Save')
             * @member {String}
             */
            Code: '',
            /**
             * Command text. Setting this property's value automatically updates all UI elements bound to this command.
             * @member {Observable<String>}
             */
            Text: '',
            /**
             * Command icon. Setting this property's value automatically updates all UI elements bound to this command.
             * @member {Observable<String>}
             */
            IconCode: '',
            /**
             * Toggles visibility of all UI elements bound to this command.
             * @member {Observable<Boolean>}
             */
            Visible: true,
            /**
             * Toggles the enabled state of all UI elements bound to this command.
             * Disabled commands cannot be executed.
             * @member {Observable<Boolean>}
             */
            Enabled: true,
            /**
             * Command hint (ToolTip)
             * @member {Observable<String>}
             */
            Hint: '',

            PostModelData: true,

            initialize: function (config, owner) {
                var me = this;

                Object.append(me, config);

                //convert plain properties to observables
                $.each(observableProps, function (idx, propName) {
                    ko.createProperty(me, propName, defaults[propName]);//.cmd = me;
                });
                me.parent(config, owner);

                me.InternalEnabled = me.Enabled;
                me.InternalVisible = me.Visible;
            },

            _getOwner: function () {
                return this[TS.Constants.ownerProp];
            },

            /**
             * Executes the command
             */
            execute: function (params) {
                var me = this,
                    owner = me._getOwner(),
                    cmdCode = '';

                if (me.categoryCode) {
                    cmdCode = me.categoryCode + '.';
                }

                cmdCode = cmdCode + me.Code;
                TS.trace('Executing command ' + cmdCode);

                try {
                    //TODO: start timer only if command is configured to time-out
                    owner.executeCommand(cmdCode);
                }
                catch (ex) {
                    TS.trace('cmd binding - execute error');
                    TS.Notify.error('Error executing command ' + cmdCode + ', error: ' + ex.message);
                }
                finally {

                }
            },

            hasHandler: function () {
                return TS.hasValue(this.handler);
            },

            _setData: function (config) {
                var me = this;

                if (config.hasOwnProperty('Text'))
                    me.Text(config.Text);

                if (config.hasOwnProperty('Visible'))
                    me.Visible(config.Visible);
                else
                    me.Visible(true);

                if (config.hasOwnProperty('Enabled'))
                    me.Enabled(config.Enabled);
                else
                    me.Enabled(true);

                me.parent(config);
            }
        });


    ko.bindingHandlers['cmd'] = {

        init: function (element, valueAccessor, allBindingsAccessor, domain, bindingContext) {
            //console.time('cmd - init');
            var eventName = 'click',
                newValueAccessor,
                commandName,
                cmd,
                owner;

            if (instanceOf(domain, TS.domain.Command)) {
                cmd = domain;
                owner = cmd._getOwner();
                commandName = cmd.categoryCode + '.' + cmd.Code;
            }
            else {
                commandName = TS.unwrap(valueAccessor());
                cmd = domain.getCommand(commandName);
                owner = domain;
            }

            if (!cmd) {
                TS.Log.warn('Cannot find command [' + (commandName || '') + ']');
                return;
            }


            var hint = TS.unwrap(cmd.Hint)
            if (hint != '') {
                var el = $(element);
                el.kendoTooltip({
                    position: "bottom",
                    content: hint
                });
            }

            newValueAccessor = function () {
                var result = {};

                result[eventName] = function () {
                    try {
                        //TODO: start timer only if command is configured to time-out
                        owner.executeCommand(commandName);
                    }
                    catch (ex) {
                        TS.trace('cmd binding - execute error');
                        TS.Notify.error('Error executing command ' + commandName + ', error: ' + ex.message);
                    }
                    finally {
                        //TS.trace('cmd binding - finally');
                    }
                };
                return result;
            };

            var ret = ko.bindingHandlers['event']['init'].call(this, element, newValueAccessor, allBindingsAccessor, domain, bindingContext);
            //console.timeEnd('cmd - init');
            return ret;
        },

        update: function (element, valueAccessor, allBindingsAccessor, domain, bindingContext) {
            //console.time('cmd - update');

            var commandName = TS.unwrap(valueAccessor()),
                cmd,
                isDisabled;

            if (domain.Code && domain.Text)
                cmd = domain;
            else
                cmd = domain.getCommand(commandName);

            if (!cmd) {
                TS.Log.warn('Cannot find command [' + (commandName || '') + ']');
                return;
            }

            //CP 20130713 - don't use the 'text' binding, it removes any other non-text nodes
            //wee need to add an <i> node if the command has iconCode
            ko.bindingHandlers.html.update(element, function () {
                var iconCode = TS.unwrap(cmd.IconCode),
                    cmdCode = TS.unwrap(cmd.Code),
                    ret = TS.unwrap(cmd.Text);

                // CP 20150106
                // in fwk, the IconCode getter returns the value of the Code property (see BaseCommandDefinition)
                // which is not cool; so check against this
                if (iconCode && iconCode != cmdCode)
                    ret = "<i class='fa fa-" + iconCode + "'></i> " + ret;
                return ret;
            }, allBindingsAccessor, domain, bindingContext);

            if (element.nodeName.toUpperCase() == 'A') {
                ko.bindingHandlers.css.update(element, function () {
                    var isDisabled = (TS.unwrap(cmd.InternalEnabled) === false);
                    if (isDisabled)
                        return 'ts-command-disabled';
                    return '';
                }, allBindingsAccessor, domain, bindingContext);
            } else {
                ko.bindingHandlers.disable.update(element, function () {
                    return (TS.unwrap(cmd.InternalEnabled) === false);
                }, allBindingsAccessor, domain, bindingContext);
            }

            ko.bindingHandlers.visible.update(element, function () {
                return !(TS.unwrap(cmd.InternalVisible) === false);
            }, allBindingsAccessor, domain, bindingContext);
            //console.timeEnd('cmd - update');
        }
    };

})();